let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7uAi5")).then(() => parcelRequire('fyj1u'));